import { ArrowRight } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArrowRight12Line = createIcon(ArrowRight, 12, "Line");
export const IconArrowRight16Line = createIcon(ArrowRight, 16, "Line");
export const IconArrowRight20Line = createIcon(ArrowRight, 20, "Line");
export const IconArrowRight24Line = createIcon(ArrowRight, 24, "Line");
export const IconArrowRight32Line = createIcon(ArrowRight, 32, "Line");
export const IconArrowRight48Line = createIcon(ArrowRight, 48, "Line");
export const IconArrowRight64Line = createIcon(ArrowRight, 64, "Line");
